import React, { Component } from 'react';
import { Banner } from '../../Components'
import { Switch, Route } from 'react-router-dom'

import 'rc-steps/assets/index.css';
import 'rc-steps/assets/iconfont.css';
import Steps, {  } from 'rc-steps';
import './New.scss'
import Step from './Step'

import PersonalDetails from './1.PersonalDetails'
import ContactDetails from './2.ContactDetails'
import Speciality from './3.Speciality'
import SpecialInterests from './4.SpecialInterests'
import PatientsDetails from './5.PatientsDetails'
import BillingPolicy from './6.BillingPolicy'
import ClinicPractice from './7.ClinicPractice'
import Hospital from './8.Hospital'
import AdditionalDetails from './9.AdditionalDetails'

import { observer, inject } from 'mobx-react'
@inject('store')
@observer    
class New extends Component {

	componentDidMount() {
		this.props.store.clearDoctor()
	}
	

	render() {
		return (
			<div className="new-listing-page">
				<Banner title="Create new listing" subtitle="Fill out the following details below to create a listing on the private directory." />
				<div className="container page">
					<div className="row">
						<div className="col-md-3">
							<div>
							<Steps direction="vertical" current={this.props.store.step}>
								{this.props.store.steps.map((step, index) =>
									<Step
										key={index}
										lastCompletedStep={this.props.store.lastCompletedStep}
										step={index + 1}
										currentStep={this.props.store.step}
										{...step} />)}
							</Steps>
							</div>	
						</div>
						<div className="col-md-9">
							<Switch>
								<Route path="/listing/new" exact component={PersonalDetails} />
								<Route path="/listing/new/2" exact component={ContactDetails} />
								<Route path="/listing/new/3" exact component={Speciality} />
								<Route path="/listing/new/4" exact component={SpecialInterests} />
								<Route path="/listing/new/5" exact component={PatientsDetails} />
								<Route path="/listing/new/6" exact component={BillingPolicy} />
								<Route path="/listing/new/7" exact component={ClinicPractice} />
								<Route path="/listing/new/8" exact component={Hospital} />
								<Route path="/listing/new/9" exact component={AdditionalDetails} />
							</Switch>
						</div>
					</div>
				</div>
				
			</div>
		);
	}
}



export default New;


// WEBPACK FOOTER //
// ./src/Containers/Listing/New.js